import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Button, Alert } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';

/**
 * Error view for the Build component
 * @param {Object} props - Component props
 * @param {Object} props.error - Error object or message
 * @param {Function} props.onRetry - Function to retry loading data
 * @returns {React.ReactElement} Error view component
 */
const ErrorView = ({ error, onRetry }) => {
  const errorMessage = error?.message || error || 'An unknown error occurred';

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center', 
        justifyContent: 'center',
        minHeight: '300px',
        width: '100%',
        textAlign: 'center',
        px: 3
      }}
    >
      <Alert 
        severity="error" 
        sx={{ 
          mb: 3, 
          width: '100%', 
          maxWidth: '600px',
        }}
      >
        {errorMessage}
      </Alert>
      
      <Typography 
        variant="h6" 
        color="text.primary"
        sx={{ mb: 2 }}
      >
        Failed to load development plan
      </Typography>
      
      <Typography 
        variant="body1" 
        color="text.secondary"
        sx={{ maxWidth: '600px', mb: 3 }}
      >
        There was a problem loading your development phases and tasks. You can try again or check back later.
      </Typography>
      
      {onRetry && (
        <Button
          variant="contained"
          color="primary"
          startIcon={<RefreshIcon />}
          onClick={onRetry}
        >
          Try Again
        </Button>
      )}
    </Box>
  );
};

ErrorView.propTypes = {
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  onRetry: PropTypes.func
};

export default ErrorView;